//import library
import {library} from '@fortawesome/fontawesome-svg-core';

//import icons
import { faMapMarkerAlt, faStamp, faBuilding, faPlus, faMinus, faVectorSquare } from '@fortawesome/free-solid-svg-icons';
import { faMap, faWindowMaximize } from '@fortawesome/free-regular-svg-icons';
import { faHtml5, faGithub, faJsSquare, faReact, faSass } from '@fortawesome/free-brands-svg-icons';


library.add(
    faMapMarkerAlt,
    faMap,
    faStamp,
    faBuilding,
    faPlus,
    faMinus,
    faWindowMaximize,
    faVectorSquare,
    faGithub,
    faJsSquare,
    faReact,
    faSass,
    faHtml5
)